import axios from 'axios';
import { GET, RESPONSE_TYPES } from '@constants/generic-constants';
import { store } from '../store/index.js';
import { setAuthorized } from '@reducers/seller-center/userinfo-slice/index.js';
import { isDevMode, isCP } from '@utils/app-utils.js';
import { setAuthorized as cpSetAuthorized } from '@reducers/cp/user-slice/index.js';
import { getCookie, removeCookie } from '../auth/helper/helper.js';
import { getErrorString, isDubizzleTenant } from '@utils/utils.js';
// import * as Sentry from '@sentry/react';
import { clientQuery } from '../index';

const TIMEOUT = 90 * 1000;

export default class NetworkManager {
  static performRequest(
    url,
    data,
    type,
    signal,
    responseType,
    encodePlusSign = true,
    contentType,
    disableKC = false,
    withCredentials = true
  ) {
    if (!navigator.onLine) {
      return
    }
    // const logError = (error, status) => {
    //   const state = store?.getState();
    //   const userProfile = isCP() ? state?.cpUserData?.userInfo : state?.userData?.userInfo?.userProfile;
    //   Sentry.captureMessage(`${type} call failed with status ${status}`, {
    //     level: 'error',
    //     extra: {
    //       apiUrl: url,
    //       body: data,
    //       type: type,
    //       userId: userProfile?.id,
    //       email: userProfile?.email,
    //       status,
    //       error: getErrorString({ error }),
    //     },
    //   });
    // };
    const token = isDevMode()
      ? isCP()
        ? getCookie('access_token')
        : (getCookie('local_sc_access_token') ??
          'eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJzd2xvcjNOU3FlMTA5UTRPTU41MF9ZdHgwb1VNUDlxbFlpRlhBNk91aW9FIn0.eyJleHAiOjE3NzU1NDQ1ODEsImlhdCI6MTc0NDAwODU4MSwianRpIjoiODNjYjNhZTAtZWQxYS00OTg5LTk4MDMtOTk2ZGM3ZTY1MzZmIiwiaXNzIjoiaHR0cHM6Ly9hdXRoLmRldi5vbHgtcGsucnVuL2F1dGgvcmVhbG1zL29seC1wayIsInN1YiI6ImQ1NmQzYjU4LWFhNmItNDljMS05YTM1LWQwMTllZTkyYTI3MiIsInR5cCI6IkJlYXJlciIsImF6cCI6ImZyb250ZW5kIiwic2Vzc2lvbl9zdGF0ZSI6IjJhNWM2NmQ1LTFlYzMtNDVmOC1iNDM4LTgxNDkzYTRmN2QzYyIsImFsbG93ZWQtb3JpZ2lucyI6WyIqIl0sInNjb3BlIjoib3BlbmlkIHJlYWxtX3JvbGVzIG9mZmxpbmVfYWNjZXNzIHVzZXJfcHJvZmlsZSIsInNpZCI6IjJhNWM2NmQ1LTFlYzMtNDVmOC1iNDM4LTgxNDkzYTRmN2QzYyIsInJlYWxtX3JvbGVzIjpbInNlbGxlci1jZW50ZXItdXNlciIsIm9mZmxpbmVfYWNjZXNzIiwiZGVmYXVsdC1yb2xlcy1vbHgtcGsiLCJ1bWFfYXV0aG9yaXphdGlvbiIsInVzZXIiXSwiZXh0ZXJuYWxfaWQiOiJkNTZkM2I1OC1hYTZiLTQ5YzEtOWEzNS1kMDE5ZWU5MmEyNzIiLCJzdG9yZUlkIjoiMSJ9.nSyjtUOve4cpRAgcwTgJECPUEJAPwICSLXcDMf-k3dt7cMb6Zxtk7v_eSpzLyNy_aziHXGV_R2WVNHAsJndDCXQn2hy_q-sB_FaRDq1Df776fTMA6u5070Ou2Nac50F_kKIlRq1oK44YMaKhU7IVjPw8le_vTji39BXEfmz-AELRD9JMxHixpCZe1steqXCOJsf57TAtf6Fo8PSbO-cMJZKEGRAOi-9UPA8hde_fYsB3RZptknHKzS_3p4jSPTcK4Vwrc2AgXmzx69BT8BFjTIFWAOpuHIusAVGDkCiFQbdDVfh9Jeh8z4iH4UJQF5nB4YxkpA6WwCT2jIeBRgcHWA')
      : null;
    const roleBasedConfig = isCP()
      ? { headers: { Authorization: token ? `Bearer ${token}` : '' }, withCredentials: true }
      : {
          headers: {
            ...(isDevMode()
              ? {
                  Authorization: token ? `Bearer ${token}` : '',
                }
              : {}),
            ...(!disableKC ? { ENABLE_KEYCLOAK: false /*isOLXTenant()*/ } : {}),
            ...(withCredentials ? { withCredentials: true } : {}),
            ...(contentType ? { 'Content-Type': contentType } : {}),
          },
        };

    let config = {
      adapter: 'fetch',
      method: type,
      url: encodePlusSign ? url.replaceAll('+', '%2B') : url,
      data: data,
      responseType,
      ...roleBasedConfig,
      ...(signal ? { signal: signal } : {}),
    };
    return new Promise((resolve, reject) => {
      axios(config, {
        timeout: TIMEOUT,
      })
        .then((response) => {
          // store.dispatch(setAuthorized(true));
          resolve(response);
        })
        .catch(async (error) => {
          const status = error?.response?.status;
          if (responseType === RESPONSE_TYPES?.blob) {
            const jsonText = await error?.response?.data?.text?.();
            if (jsonText) {
              try {
                const data = JSON.parse(jsonText);
                error.response.data = data;
              } catch(_err) {}
            }
          }
          // if (status !== 401) logError(error, status);
          if (status === 403) {
            reject({ status, error });
          } else if (status === 401) {
            clientQuery?.clear();
            if (isCP() || isDubizzleTenant()) {
              if (isCP()) {
                store.dispatch(cpSetAuthorized(false));
                removeCookie('cp_access_token');
              } else {
                store.dispatch(setAuthorized(false));
                removeCookie('sc_access_token');
              }
              reject({ status, error });
            } else {
              store.dispatch(setAuthorized(false));
              removeCookie('sc_access_token');
              reject({ status, error });
            }
          } else if (status === 404 && type === GET) {
            // const errorPathname = `${BASE_PATH}${isCP() ? CP_NOT_FOUND : OMS_NOT_FOUND}`;
            // redirectToPath(errorPathname);
            reject({ status, error });
          } else if (status === 500) {
            // const errorPathname = `${BASE_PATH}${isCP() ? CP_SERVER_ERROR : OMS_SERVER_ERROR}`;
            // redirectToPath(errorPathname);
            reject({ status, error });
          } else {
            reject({ requestError: error });
          }
        });
    });
  }
}
